// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue                  from 'vue'
import App                  from './App'
import VueRouter            from "vue-router"
import router               from './router'
// const rax                   = require('retry-axios');
import axios                from 'axios';
import axiosRetry           from 'axios-retry';
import VueTheMask           from 'vue-the-mask'
import VueMoney             from 'v-money'
import mobile               from 'mobile-device-detect';
import Autocomplete         from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
import VueAwesomeSwiper     from 'vue-awesome-swiper'
import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'
// var url                     = "http://localhost:8081";
var url                     = "https://neoplasiaslitoral.negociar.tech";
Vue.use(VueRouter)
// Vue.use(VueTrumbowyg);
Vue.use(VueTheMask)
Vue.use(VueMoney)
Vue.use(mobile)
Vue.use(VueAwesomeSwiper)
Vue.use(Autocomplete)
Vue.config.productionTip    = false
window._app;
// const interceptorId         = rax.attach();


axios.defaults.baseURL      = url;
if (!window.cordova && location.hostname != "localhost") {
    window.console.log      = function(){};
}
if (window.cordova || location.hostname != "localhost") {
}
axios.defaults.timeout  = 15000;

axiosRetry(axios, {
  // retryCondition: axiosRetry.isNetworkError, // default
  // retryCondition: axiosRetry.isAnyError // alternative
    retries: 3,
    retryDelay: () => 2000,  
    retryCondition: (response) => {  // custom
        console.log("retryCondition>", response.code)
        return response.code == 'ECONNABORTED';
    }
});

window.axios                = axios;

/* eslint-disable no-new */
new Vue({
  	el:                  '#app',
  	router,
  	components: {
        App
    },
  	template:            '<App/>',

    data: {
        "logged":       false,
        "cordova":      window.cordova || null,
        "user":  {
            "cod":      null,
            "token":    null,
            "tipo":     "contratante"
        },
        "mobile":       mobile,
        "tmp":  {
            "pacientesForm": null,
            "dashboardAgendamentos": {
                "itens": []
            },
            "dashboardMural": {
                "itens": []
            },
            "pacientes": {
                "itens": []
            },
            "profissionais": {
                "itens": []
            },   
            "agendamentos": {
                "itens": []
            },                                        
        },
        "modalAgendarData": null,
        "modal": {
        },
        "config": {
            "url":      url,
            "telefone": "tel:4733485093",
            "whatsapp": "https://api.whatsapp.com/send?phone=5547992797624&text=",
            "instagram": "https://instagram.com/neoplasiaslitoral",
            "facebook": "https://www.facebook.com/neoplasiaslitoral",
            "site": "https://neoplasiaslitoral.com.br/",
            "googleAnalytics": {
                "id":   "G-DXBM92NQQW"
            },
            "pusher": {
                "key": ""
            },
            "money": {
                "decimal":            ',',
                "thousands":          '.',
                "prefix":             '',
                "suffix":             '',
                "precision":          2,
                "masked":             false
            }      
        }
    },
    methods: {
        initialize: function() {
            console.log("app.initialize()");
            var self             = this;

            gtag('js', new Date());
            gtag('config', self.config.googleAnalytics.id);

            window.confirmWeb   = window.confirm;
            window.confirm      = function(msg, callback) {
                if (window.confirmWeb(msg)) {
                    callback();
                }
            }

            var self        = this;
            window.__app    = self;
            document.addEventListener('deviceready', this.onDeviceReady.bind(this), false);
            var login       = self.checkLogin();

            self.fixClass();
        },
        scrollTop: function() {
            setTimeout(function() {
                $(".dashboard-content-inner")[0].scrollTo({
                    top:    0
                });     
            }, 100);
        },         
        atualizarPushToken: function() {
            console.log("push > atualizarPushToken()")
            var self = this;
            if (self.logged && window.localStorage.pushToken) {
                axios.post("api/push-notification.php", {
                    "_cod":         self.user.cod,
                    "_token":       self.user.token,
                    "dispositivo":  self.mobile.osName,
                    "pushToken":    localStorage.getItem('pushToken')
                })
                .then(response => {
                    window.localStorage.setItem("pushTokenSalvo", new Date());
                    console.log("push > Salvou push", response)
                })
                .catch(error => {
                    console.log("push > Erro:", error)
                });                 
            }                
        },
        checkPushNotificationPermission: function(requested){
            var self = this;
            window.FirebasePlugin.hasPermission(function(hasPermission){
                if(hasPermission){
                    console.log("push > Remote notifications permission granted");
                    self.getPushNotificationToken();
                }else if(!requested){
                    console.log("push > Requesting remote notifications permission");
                    window.FirebasePlugin.grantPermission(self.checkPushNotificationPermission.bind(this, true));
                }else{
                    console.log("push > Notifications won't be shown as permission is denied");
                }
            });
        },    
        getPushNotificationToken: function(){
            var self = this;
            window.FirebasePlugin.getToken(function(token){
                console.log("push > Got FCM token: " + token);
                localStorage.setItem('pushToken', token);
                self.atualizarPushToken();
            }, function(error) {
                console.log("push > Failed to get FCM token", error);
            });
        },     
        go: function(route, data) {
            console.log("app.go()", route, data)
            var self = this;
            if (!data) {
                data = {};
            } else {
                data = JSON.parse(data);
                console.log("fez parse", data);
            }
            self.$router.push({ 
                name:       route,
                query:      data
            }).catch(()=>{});               
            $("body .overhang").fadeOut(500);
        },
        redirect: function(route) {
            console.log("app.redirect()", route)
            var self = this;
            self.$router.push({ 
                path:       route
            }).catch(()=>{});               
            $("body .overhang").fadeOut(500);
        },                  
        onPushNotification: function(message) {
            console.log("push > onPushNotification()", message);
            var self        = this;

            if (self.mobile.osName == "iOS") {
                if (message.messageType == "notification" && message.aps) {
                    if (message.aps.alert) {
                        message.title   = message.aps.alert.title;
                        message.body    = message.aps.alert.body;
                    }
                }
            }

            if (message.messageType == "notification" && message.tap && message.route) {
                self.go(message.route, message.query || null);
            }

            if (message.messageType == "notification" && message.title && message.body) {

                if (message.route) {
                    if (message.route == self.$route.name) {
                        return false;
                    }
                }

                window.ultimoPush   = message;
                var link = "";
                if (message.route) {
                    link = "onclick='window.__app.go(\"" + message.route + "\", window.ultimoPush.query)'";
                } else if (message.link) {
                    link = "onclick='window.open(\"" + message.link + "\", \"_system\")'";
                }

                navigator.vibrate(1000); 
                navigator.notification.beep(1);

                $("body").overhang({
                    custom: true,
                    primary: "#FFFFFF",
                    accent: "#FFFFFF",
                    textColor: "#333333",
                    html: true,
                    message: "<a " + link + "><h4>" + message.title + "</h4><p>" + message.body + "</p></a>",
                    closeConfirm: "true",
                    customClasses: "push-notification",
                    callback: function (selection) {
                        console.log("callback notification", selection)
                        // if (message.route) {
                            
                            // iframe.src  = message.route;
                        // }
                    }
                });

            }

        },               
        onDeviceReady: function() {
            console.log("onDeviceReady()")
            var self    = this;

            window.open = cordova.InAppBrowser.open;

            if(window.MobileAccessibility){
                console.log("Desativa fonte menor Android")
                window.MobileAccessibility.usePreferredTextZoom(false);
            }            

            if (self.mobile.isTablet) {
                console.log("É tablet, deixa a orientation livre");
                window.screen.orientation.lock(window.screen.orientation.type);
                window.screen.orientation.unlock();
            } else {
                window.screen.orientation.lock("portrait");
            }

            self.checkPushNotificationPermission();

            window.FirebasePlugin.onMessageReceived(function(message) {
                console.log("push > onMessageReceived", message);
                try {
                    console.log(message);
                    self.onPushNotification(message);
                } catch(e) {
                    console.log("push > Exception in onMessageReceived callback: "+e.message);
                }

            }, function(error) {
                console.log("push > Failed receiving window.FirebasePlugin message", error);
            });

            window.FirebasePlugin.onTokenRefresh(function(token){
                console.log("push > Token refreshed: " + token)
                window.localStorage.setItem("pushToken", token);

            }, function(error) {
                console.log("push > Failed to refresh token", error);
            });


            self.backbutton = function(e){
                console.log("backbutton", e)
                e.preventDefault();
                self.back();
                return false;
            }

            document.addEventListener('backbutton', self.backbutton, false); 

            window.alert      = function(msg){
                navigator.notification.alert(msg, function(){}, "", "Ok");
                // $("body").overhang({
                //     type: "info",
                //     message: msg
                // });            

            };

            window.confirm    = function(msg, callback){
                navigator.notification.confirm(msg, function(i) {
                    if (i == 1) {
                        callback();
                    }
                }, "", ['Sim', 'Cancelar']);
            };
            
        },
        setUser: function(usuario) {
            var self    = this;
            return new Promise(function(resolve, reject) {
                window.localStorage.setItem("_usuario", JSON.stringify(usuario));
                self.logged    = true;
                self.user   = usuario;
                resolve(usuario);

            });
        },   
        getUser: function(force) {
            var self        = this;
            console.log("getUser()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.user.cod, 
                        "_token":       self.user.token
                    }
                };

                axios.get("api/usuarios.php", form)
                .then(response => {
                    
                    console.log("getUser() response", response);
                    self.setUser(response.data.result);
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getUser() error", error);
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.logout();
                        }
                    }
                    
                    reject(error);
                    
                });   
            });   
        },          
        checkLogin: function() {
            var self    = this;
            if (!window.localStorage.getItem("_usuario")) {
                return false;
            } else {
                var usuario = null;
                try {
                    usuario = JSON.parse(window.localStorage.getItem("_usuario"));
                    self.setUser(usuario);
                    self.getUser();
                    return true;
                } catch(err) {
                    console.log("checkLogin() error parse", err);
                    return false;
                }
            }
        },
        logout: function() {
            var self = this;
            $(".mm-menu").hide();
            $("#mm-blocker").hide();
        	loading.show();
        	window.localStorage.clear();
            // self.go("Introducao");
            // setTimeout(function() {

        	    location.reload();
            // }, 1000);
        },
        back: function() {
            var self = this;
            console.log("back()", self, window.history.length);
            if ($(".tingle-modal--visible")[0]) {
                $(".tingle-modal--visible").hide();
                $(".tingle-modal").removeClass("tingle-modal--visible");
                console.log("back -> Esconde modal")
            } else {
                console.log("back -> Normal")

                loading.show();
                if (window.history.length > 2) {
                    $(".content-load .dashboard-container").fadeOut(100);                
                }

                // if (self.$route.meta.auth == false) {
                //     window.history.go(-3);
                // } else {
                    window.history.back();
                // }
            }

        },
        fixClass: function() {
            var self = this;
            if (self.$route) {
                $("body").attr("class", "");
                $("body").addClass("current-page-" + self.$route.name.toLowerCase());            
            }
        },
        addEvents: function() {
            var self = this;
            $("body").on("click", "a[target='_blank']", function(e) {
                console.log("open InAppBrowser", e.currentTarget.href, e);
                if (window.cordova) {
                    e.preventDefault();
                    window.open = cordova.InAppBrowser.open;
                    window.open(e.currentTarget.href, "_system");
                }

            });            
        },

        openModal: function(nome, html) {
            var self        = this;

            console.log("openModal()", nome)

            self.modal[nome]   = new tingle.modal({
                footer:         false,
                stickyFooter:   false,
                closeMethods:   ['overlay', '', 'escape'],
                closeLabel:     "",
                cssClass:       [(nome), "modal-default"]
            });   
            setTimeout(function() {
                if (!html) {
                    self.modal[nome].setContent(document.querySelector('#' + nome).innerHTML);      
                } else {
                    self.modal[nome].setContent(html);      
                }
                self.modal[nome].open();
                loading.hide();
                setTimeout(function() {
                    $("." + nome).append('<a class="close" onclick=\'window.__app.modal["' + nome + '"].close();\'><i class="material-icons">close</i></a>');    
                }, 100);
            }, 500);


        },        
        modalAgendarSubmit: function() {
            var self = this;
            console.log("modalAgendarSubmit()", self.modalAgendarData);

            var form = {
                "_cod":             self.user.cod,
                "_token":           self.user.token,
                "HR_INICIO":        self.modalAgendarData.agendamento.HR_INICIO,
                "CD_AGENDA":        self.modalAgendarData.agendamento.CD_AGENDA,
                "NR_SEQUENCIA":     self.modalAgendarData.agendamento.NR_SEQUENCIA,
                "CD_MEDICO_AGENDA": self.modalAgendarData.agendamento.CD_MEDICO_AGENDA,
            }

            loading.show();
            
            axios.post("api/agendamento.php", form)
            .then(response => {

                console.log("ok", response.data.result)
                loading.hide();
                alert(response.data.message);
                if (response.data.result) {
                    self.modalAgendar.close();
                    self.go("Dashboard");
                }

            })
            .catch(error => {
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });            
        }
    },
    created: function() {
    	var self = this;
        if (!window.localStorage.getItem("_intro") && self.mobile.isMobile && self.$route.name != "RecuperarSenha") {
            self.go("Introducao");
        }

        // if ()
        self.initialize();  
        loading.show();
        self.addEvents();
    },
    mounted: function() {
        console.log("mounted geral >>");
        var self = this;
        setTimeout(function() {
            $("#wrapper").fadeIn(1000);
        }, 1000);
    },
	watch:{
	    $route (to, from){
	        var self = this;
            self.fixClass();
	        setTimeout(function() {
	        	window.fixHeight();
                window.scrollTo({
                    top: 0
                });
                window.mmenuInit();
                gtag('config', self.config.googleAnalytics.id, {'page_title': to.meta.title});                 
	        }, 100);
	    }
	},
    on: {
    }      	
})



// WEBPACK FOOTER //
// ./src/main.js